import { render, staticRenderFns } from "./mallProductList.vue?vue&type=template&id=1a1ddb62&scoped=true"
import script from "./mallProductList.vue?vue&type=script&lang=ts"
export * from "./mallProductList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1ddb62",
  null
  
)

export default component.exports